/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scheduled: NonNullable<unknown>, done: NonNullable<unknown> }} Today_Week_CountInputs */

const en_us2_today_week_count = /** @type {(inputs: Today_Week_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.scheduled === 1 || i?.scheduled === "1")) return /** @type {LocalizedString} */ (`${i?.done} of 1 workout`);
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.scheduled} workouts`)
	
};

const pt_br2_today_week_count = /** @type {(inputs: Today_Week_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.scheduled === 1 || i?.scheduled === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 treino`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.scheduled} treinos`)
	
};

const es_419_today_week_count = /** @type {(inputs: Today_Week_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.scheduled === 1 || i?.scheduled === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 entrenamiento`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.scheduled} entrenamientos`)
	
};

const pt_pt2_today_week_count = /** @type {(inputs: Today_Week_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.scheduled === 1 || i?.scheduled === "1")) return /** @type {LocalizedString} */ (`${i?.done} de 1 treino`);
	return /** @type {LocalizedString} */ (`${i?.done} de ${i?.scheduled} treinos`)
	
};

const fr_fr2_today_week_count = /** @type {(inputs: Today_Week_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.scheduled === 1 || i?.scheduled === "1")) return /** @type {LocalizedString} */ (`${i?.done} sur 1 séance`);
	return /** @type {LocalizedString} */ (`${i?.done} sur ${i?.scheduled} séances`)
	
};

const de_de2_today_week_count = /** @type {(inputs: Today_Week_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.scheduled === 1 || i?.scheduled === "1")) return /** @type {LocalizedString} */ (`${i?.done} von 1 Training`);
	return /** @type {LocalizedString} */ (`${i?.done} von ${i?.scheduled} Trainings`)
	
};

const it_it2_today_week_count = /** @type {(inputs: Today_Week_CountInputs) => LocalizedString} */ (i) => {
	if ((i?.scheduled === 1 || i?.scheduled === "1")) return /** @type {LocalizedString} */ (`${i?.done} di 1 allenamento`);
	return /** @type {LocalizedString} */ (`${i?.done} di ${i?.scheduled} allenamenti`)
	
};

/**
* | scheduled | output |
* | --- | --- |
* | "1" | "{done} of 1 workout" |
* | * | "{done} of {scheduled} workouts" |
*
* @param {Today_Week_CountInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_week_count = /** @type {((inputs: Today_Week_CountInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Week_CountInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_week_count(inputs)
	if (locale === "es-419") return es_419_today_week_count(inputs)
	if (locale === "pt-PT") return pt_pt2_today_week_count(inputs)
	if (locale === "fr-FR") return fr_fr2_today_week_count(inputs)
	if (locale === "de-DE") return de_de2_today_week_count(inputs)
	if (locale === "it-IT") return it_it2_today_week_count(inputs)
	return en_us2_today_week_count(inputs)
});
export { today_week_count as "today.week_count" }